import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function OutCome() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>The Outcomes</h2>
            <p>
              A cleaner interface with more sleekness and attention to detail,
              along with the many features that come along with setting up a
              platform on BigCommerce. We delivered a solution that is
              optimized, more value-driven, includes relevant details, and is
              ultimately designed to be human-centric.
            </p>
            <p>
              It is easier to see how the business is upscaling and figuring out
              the right strategies is less complicated now. The eCommerce
              platform along with the many outlets falls under the bracket of
              BigCommerce.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="mt-5">
              <StaticImage
                src="../../../images/case-studies/alhussaini/tek-img_06.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1382}
                height={585}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default OutCome;
